import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { Container } from "reactstrap";
import { Button } from "shared";
import t from "utils/Lang";
import ModalCreateGroup from "pages/CustomField/components/ModalCreateGroup";
import ModalCreateField from "pages/CustomField/components/ModalCreateField";
import { connect } from "react-redux";
import api from "api";
import "./index.scss";
import GroupItem from "pages/CustomField/components/GroupItem";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { sortNewFieldGroup, sortNewGroup } from "utils/CustomFieldHelper";
import ModalCreateTab from "pages/CustomField/components/ModalCreateTab";
import { useHistory } from "react-router-dom";

type CustomTabDetailProps = {
  user?: any;
};

const CustomTabDetail = ({ user }: CustomTabDetailProps) => {
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [isOpenModalTab, setOpenModalTab] = useState(false);
  const toggleModalTab = () => setOpenModalTab(!isOpenModalTab);
  const [selectedGroup, setSelectGroup] = useState<any>(null);
  const [selectedFieldId, setSelectFieldId] = useState<any>(null);
  const [groupData, setGroupData] = useState<any>();
  const [isOpenModalGroup, setOpenModalGroup] = useState(false);
  const toggleModalGroup = () => setOpenModalGroup(!isOpenModalGroup);
  const [isOpenModalField, setOpenModalField] = useState(false);
  const toggleModalField = () => setOpenModalField(!isOpenModalField);
  const match = useRouteMatch("/settings/custom-field/:tab_id");
  const params: any = match?.params;
  const tabId = params?.tab_id;
  useEffect(() => {
    if (tabId) fetchGroupData();
  }, [tabId]);
  const fetchGroupData = async () => {
    setLoading(true);
    const res = await api.getGroups(tabId);
    if (res.status === "ok") {
      setGroupData(res);
    }
    setLoading(false);
  };
  const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
    userSelect: "none",
    // change background colour if dragging
    // background: isDragging ? 'var(--color-highlight-action)' : 'none',
    ...draggableStyle,
  });
  const onDuplicate = (group: any) => async () => {
    const data = {
      name: `${group.name} copy`,
      studio_tab_id: parseInt(tabId),
      languages: {
        vi: `${group.name} copy`,
        en: `${group.name} copy`,
      },
    };
    const res = await api.createGroup(data);
    if (res.status === "ok") {
      const groupCreated = res.studio_group;
      const reqFields = group.fields.map((f: any) => {
        return api.createField({
          name: `${f.name} copy`,
          studio_group_id: groupCreated.id,
          field_data_type: f.field_data_type,
          extra_data: JSON.stringify(f.extra_data),
          languages: {
            vi: `${f.name} copy`,
            en: `${f.name} copy`,
          },
        });
      });
      await Promise.all(reqFields);
      fetchGroupData();
    }
  };
  const renderGroupItem = (group: any, index: number) => {
    return (
      <Draggable key={group.id} draggableId={`${group.id}`} index={index}>
        {(dragProvided, dragSnapshot) => {
          return (
            <div
              className="group-item__wrapper"
              ref={dragProvided.innerRef}
              {...dragProvided.draggableProps}
              {...dragProvided.dragHandleProps}
              style={getItemStyle(
                dragSnapshot.isDragging,
                dragProvided.draggableProps.style
              )}
            >
              <GroupItem
                group={group}
                key={group.id}
                onDuplicate={onDuplicate(group)}
                onCreateField={() => {
                  setSelectGroup(group);
                  toggleModalField();
                }}
                onEditGroup={() => {
                  setSelectGroup(group);
                  toggleModalGroup();
                }}
                onDeleteGroup={() => {
                  api.updateGroup({ is_active: false }, group.id);
                  setGroupData((data: any) => ({
                    ...data,
                    studio_groups: data.studio_groups.filter(
                      (g: any) => g.id !== group.id
                    ),
                  }));
                }}
                onSelectField={(id) => {
                  setSelectGroup(group);
                  setSelectFieldId(id);
                  toggleModalField();
                }}
              />
            </div>
          );
        }}
      </Draggable>
    );
  };
  const onDragEnd = (result: any) => {
    const { draggableId, source, destination } = result;
    if (!destination?.droppableId) return;
    if (destination.droppableId === "custom-group") {
      const newGroup = sortNewGroup(result, groupData?.studio_groups);
      api.orderGroup({
        studio_tab_id: parseInt(tabId),
        studio_group_ids: newGroup.map((g) => g.id),
      });
      setGroupData((data: any) => ({ ...data, studio_groups: newGroup }));
    } else {
      const newGroup = sortNewFieldGroup(result, groupData?.studio_groups);
      const body: any = {
        studio_group_id: parseInt(destination.droppableId),
        studio_field_ids: newGroup
          .find((g) => g.id == destination.droppableId)
          .fields.map((f: any) => f.id),
      };
      if (destination.droppableId !== source.droppableId) {
        body.studio_field_id = parseInt(draggableId);
      }
      api.orderField(body);
      setGroupData((data: any) => ({ ...data, studio_groups: [...newGroup] }));
    }
  };
  const onGroupCreated = (data: any) => {
    setGroupData((groupData: any) => ({
      ...groupData,
      studio_groups: [...groupData.studio_groups, { ...data, fields: [] }],
    }));
  };
  const onGroupUpdated = (data: any) => {
    setGroupData((groupData: any) => ({
      ...groupData,
      studio_groups: groupData.studio_groups.map((g: any) => {
        if (g.id == data.id) {
          g.name = data.name;
          g.is_show = data.is_show;
        }
        return g;
      }),
    }));
  };
  const onFieldCreated = (field: any, groupId: number) => {
    setGroupData((data: any) => ({
      ...data,
      studio_groups: data.studio_groups.map((g: any) => {
        if (g.id == groupId) {
          g.fields = [...g.fields, field];
        }
        return g;
      }),
    }));
  };
  const onFieldUpdated = (field: any, groupId: number) => {
    setGroupData((data: any) => ({
      ...data,
      studio_groups: data.studio_groups.map((g: any) => {
        if (g.id == groupId) {
          g.fields = g.fields.map((f: any) => {
            if (f.id == field.id) {
              f.name = field.name;
              f.extra_data = field.extra_data;
              f.field_data_type = field.field_data_type;
              f.is_show = field.is_show;
            }
            return f;
          });
        }
        return g;
      }),
    }));
  };
  const onTabUpdated = (tab: any) => {
    setGroupData((data: any) => ({
      ...data,
      studio_tab_name: tab.name,
      is_show: tab.is_show,
    }));
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Container className="tab-detail__container">
        <div className="page-header">
          <span className="page-title">{groupData?.studio_tab_name}</span>
          <div style={{ display: "flex" }}>
            <Button
              label={t().modal_create_tab__edit_tab}
              type="warning"
              size="small"
              icon="edit"
              onClick={() => {
                toggleModalTab();
              }}
            />
            <div style={{ width: 10 }} />
            <Button
              label={t().modal_create_group__create_group}
              type="primary"
              size="small"
              icon="add"
              onClick={toggleModalGroup}
            />
          </div>
        </div>
        <div className="page-body__wrapper">
          <Droppable
            droppableId="custom-group"
            direction="horizontal"
            type="group"
          >
            {(provided, snapshot) => {
              return (
                <div
                  className="page-body"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {groupData?.studio_groups?.map?.(renderGroupItem)}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </div>
        <ModalCreateGroup
          isOpen={isOpenModalGroup}
          toggle={toggleModalGroup}
          user={user}
          onClosed={() => {
            setSelectGroup(null);
          }}
          selectedGroupId={selectedGroup?.id}
          tab={{ name: groupData?.studio_tab_name, id: tabId }}
          onCreated={onGroupCreated}
          onUpdated={onGroupUpdated}
        />
        <ModalCreateTab
          isOpen={isOpenModalTab}
          toggle={toggleModalTab}
          user={user}
          onClosed={() => {}}
          selectedTabId={tabId}
          onDeleted={() => history.goBack()}
          onUpdated={onTabUpdated}
        />
        {selectedGroup && (
          <ModalCreateField
            isOpen={isOpenModalField}
            toggle={toggleModalField}
            user={user}
            onClosed={() => {
              setSelectGroup(null);
              setSelectFieldId(null);
            }}
            group={selectedGroup}
            selectedFieldId={selectedFieldId}
            onCreated={onFieldCreated}
            onUpdated={onFieldUpdated}
            onDeleted={(fieldId, groupId) => {
              api.updateField({ is_active: false }, fieldId);
              setGroupData((data: any) => ({
                ...data,
                studio_groups: data.studio_groups.map((g: any) => {
                  if (g.id == groupId) {
                    g.fields = g.fields.filter((f: any) => f.id != fieldId);
                  }
                  return g;
                }),
              }));
            }}
          />
        )}
      </Container>
    </DragDropContext>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(CustomTabDetail);
